import React from 'react';
import { Modal, Form, Input, Button, message } from 'antd';
import { createInvitation } from '../../services/contractor-invitation.service';

interface Props {
  open: boolean;
  contractorId: string;
  onClose: () => void;
  onSuccess: () => void;
}

interface FormValues {
  name: string;
  email: string;
}

const ERROR_MESSAGES: Record<string, string> = {
  USER_ALREADY_ASSOCIATED: 'Este usuário já está associado ao contratante.',
  PENDING_INVITATION_EXISTS:
    'Já existe um convite pendente para este email. Use a opção Reenviar Convite na listagem.',
};

export const InviteUserModal: React.FC<Props> = ({ open, contractorId, onClose, onSuccess }) => {
  const [form] = Form.useForm<FormValues>();
  const [loading, setLoading] = React.useState(false);

  const handleSubmit = async (values: FormValues) => {
    setLoading(true);
    try {
      await createInvitation(contractorId, { name: values.name, email: values.email });
      message.success(`Convite enviado para ${values.email}`);
      form.resetFields();
      onSuccess();
    } catch (err: any) {
      const code = err?.response?.data?.error;
      const msg = ERROR_MESSAGES[code] || err?.response?.data?.message || 'Erro ao enviar convite';
      message.error(msg);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  return (
    <Modal
      title="Incluir Usuário"
      open={open}
      onCancel={handleCancel}
      footer={null}
      destroyOnClose
    >
      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <Form.Item
          label="Nome"
          name="name"
          rules={[{ required: true, message: 'Informe o nome do convidado' }]}
        >
          <Input placeholder="Nome completo" />
        </Form.Item>
        <Form.Item
          label="Email"
          name="email"
          rules={[
            { required: true, message: 'Informe o email do convidado' },
            { type: 'email', message: 'Email inválido' },
          ]}
        >
          <Input placeholder="email@exemplo.com" />
        </Form.Item>
        <Form.Item style={{ marginBottom: 0, textAlign: 'right' }}>
          <Button onClick={handleCancel} style={{ marginRight: 8 }}>
            Cancelar
          </Button>
          <Button type="primary" htmlType="submit" loading={loading}>
            Enviar Convite
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};
